import axios from 'axios';
import qs from 'qs';

export const SendApiRequest = async ({
    url,
    method,
    queryParams,
    body,
    baseURL,
    signal,
    responseType,
}) => {
    url = `${url}?${qs.stringify(queryParams)}`;

    try {
        const response = await axios.request({
            baseURL: baseURL || process.env.REACT_APP_API_BASE_URL,
            url,
            method,
            queryParams,
            data: body,
            signal,
            responseType,
        });
        return response.data;
    } catch (e) {
        const data = e.response?.data;
        // Stripe errors come through as a raw StripeError object with the
        // useful message on `raw.message`. Prefer that over the generic
        // top-level fields.
        const stripeMessage =
            data && typeof data === 'object' ? data.raw?.message || null : null;
        // Express renders unmatched routes / crashes as a full HTML error page.
        // Dumping that into a toast is unreadable, so keep the HTTP status
        // instead and let callers show their own copy.
        const isHtmlBody =
            typeof data === 'string' && /^\s*<(!doctype|html)/i.test(data);
        const errorMessage =
            typeof data === 'string' && !isHtmlBody
                ? data
                : stripeMessage ||
                  data?.error ||
                  data?.message ||
                  (isHtmlBody
                      ? `Request failed (${e.response?.status || 'error'}).`
                      : null) ||
                  e.message ||
                  'Request failed';

        // Preserve the raw response body & HTTP status so callers can surface
        // richer, domain-specific errors — e.g. Stripe decline codes, and the
        // hire-block NO_PRE_AUTH_HOLD path that prompts for a manager override.
        // Existing callers that only read err.message stay backward-compatible.
        const err = new Error(errorMessage);
        err.data = data;
        err.status = e.response?.status;
        throw err;
    }
};
